import { defineMessages } from 'react-intl'

export default defineMessages({
  comingSoon: {
    id: 'SpacesPage.ComingSoon',
    defaultMessage: 'Coming Soon!'
  },
  userActivityOverTimeTitle: {
    id: 'SpaceAnalyticsPage.Section.UserAcitivityOverTime.Title',
    defaultMessage: 'User Activity'
  },
  connectorAnalyticsTitle: {
    id: 'SpaceAnalyticsPage.Section.connectorAnalyticsTitle.Title',
    defaultMessage: 'Integrations/Connector KPIs'
  },
  noActivityMetrics: {
    id: 'SpaceAnalyticsPage.Section.noActivityMetrics.Message',
    defaultMessage: 'No Activity Data for the Date Range'
  },
  title: {
    id: 'SpaceAnalyticsPage.Title',
    defaultMessage: 'Space Analytics'
  },
  cardTitle: {
    id: 'SpaceAnalyticsPage.Card.Title',
    defaultMessage: '{name} Space Statistics'
  },
  cardSubTitle: {
    id: 'SpaceAnalyticsPage.Card.SubTitle',
    defaultMessage:
      'Monitor and analyze adoption and usage across your space. For more information on understanding space analytics,'
  },
  cardSubTitleLink: {
    id: 'SpaceAnalyticsPage.Card.SubTitleLink',
    defaultMessage: 'see supporting documentation.'
  },
  close: {
    id: 'SpaceAnalyticsPage.Card.Close',
    defaultMessage: 'Close'
  },
  exportCSV: {
    id: 'Export.CSV',
    defaultMessage: 'Export CSV'
  },
  saveAsPDF: {
    id: 'SpaceAnalyticsPage.SaveAs.PDF',
    defaultMessage: 'Save as PDF'
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading...'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  note: {
    id: 'SpaceAnalyticsPage.Filters.Note',
    defaultMessage: 'Note:'
  },
  differenceNote: {
    id: 'SpaceAnalyticsPage.Filters.DifferenceNote',
    defaultMessage: 'Trend indicators are not available for custom date ranges'
  },
  missingContent: {
    id: 'SpaceAnalyticsPage.MetricSection.MissingContent',
    defaultMessage: 'MISSING CONTENT'
  }
})
